import React from 'react';
import { DragLayer } from 'react-dnd';
var MAX_ELEMS = 5;
var SoundListItemCustomDragLayer = function (props) {
    var item = props.item, itemType = props.itemType, isDragging = props.isDragging;
    function renderItem() {
        switch (itemType) {
            case 'Sound':
                var sounds_1 = item === null || item === void 0 ? void 0 : item.sound;
                return (Array.isArray(sounds_1) ? sounds_1 : [sounds_1]).slice(0, MAX_ELEMS).map(function (sound, index) {
                    var offset = index * 10;
                    var renderMoreBadge = Array.isArray(sounds_1) && sounds_1.length > MAX_ELEMS && index == 0;
                    return React.createElement("div", { key: sound.id + index, className: 'item-drag-layer ' + (renderMoreBadge ? 'badge' : ''), style: { left: -offset, bottom: -offset } },
                        renderMoreBadge && React.createElement("div", { className: 'badge' },
                            "+",
                            sounds_1.length - MAX_ELEMS),
                        React.createElement("div", { className: "artwork-container" },
                            React.createElement("img", { className: "artwork", src: sound.artwork_url, alt: "album art" })));
                });
            default:
                return null;
        }
    }
    React.useEffect(function () {
        if (isDragging) {
        }
    }, [isDragging]);
    if (!isDragging) {
        return null;
    }
    return (React.createElement("div", { style: layerStyles },
        React.createElement("div", { style: getItemStyles(props) }, renderItem())));
};
export var SoundListDragLayer = DragLayer(function (monitor) { return ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
    clientOffset: monitor.getClientOffset(),
}); })(SoundListItemCustomDragLayer);
var layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 10000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};
function getItemStyles(props) {
    var clientOffset = props.clientOffset, currentOffset = props.currentOffset, item = props.item;
    if (!clientOffset || !currentOffset || !item) {
        return {
            display: 'none',
        };
    }
    var x = clientOffset.x, y = clientOffset.y;
    var sounds = Array.isArray(item.sound) ? item.sound : [item.sound];
    var offset = (Math.min(sounds.length, MAX_ELEMS) - 1) * 10;
    var transform = "translate(" + (x + offset) + "px, " + (y - offset) + "px)";
    return {
        transform: transform,
        WebkitTransform: transform,
    };
}
//# sourceMappingURL=SoundListDragLayer.js.map